var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sc-message--system"},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.data.text)),(_vm.data.meta)?_c('p',{staticClass:"sc-message--meta"},[_vm._v(_vm._s(_vm.data.meta))]):_vm._e()],{"message":_vm.data})],2)}
var staticRenderFns = []

export { render, staticRenderFns }